<template>
  <v-hover>
      <v-card @click="seleccionaNegocio" slot-scope="{ hover }" style="border-radius:16px !important;height:200px" :class="`elevation-${hover ? 12 : 2}`">
          <v-card-title primary-title>
              <div>
                  <h3 class="headline mb-0">{{Negocio.nombrecomercial}}</h3>
                  <div>
                      {{Negocio.razonsocial}}
                  </div>
              </div>
          </v-card-title>

      </v-card>
  </v-hover>
</template>
<script>
export default {
  props: ['NegocioId'],
  data: () => {
    return {
      Negocio: false
    }
  },
  mounted () {
    this.$System.getNegocio(this.NegocioId).then(nSnap => {
      if (nSnap.exists()) {
        this.Negocio = nSnap.val()
        this.Negocio['id'] = nSnap.key
      } else {
        this.Negocio = null
      }
    })
  },
  methods: {
    seleccionaNegocio() {
      this.$System.currentUser.ref.child('Negocio').set(this.Negocio.id)
    }
  }
}
</script>